import { DataTable } from "primereact/datatable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { EmptyTenderMast, IModel, ITenderMast } from "./Tender_Mast";
import { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Fetch } from "../../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Dialog } from "primereact/dialog";
import TenderMastHistory from "./TenderMastHistory";
import { JVDropdown } from "../../../shared/JVDropdown";
import TenderAssigned from "./TenderAssigned";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter, ITenderFilter } from "./Filter";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { InputTextarea } from "primereact/inputtextarea";
import TenderWorkStream from "./TenderWorkStream";
import { DocumentList } from "./DocumentList";
import { Tooltip } from "primereact/tooltip";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { Tag } from "primereact/tag";
interface IProps {
  permission: IPermissionProps;
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
}

interface ITenderMastList {
  id?: number;
  contact_Person_ID?: number;
  title?: string;
  minBidAmnt?: string;
  description?: string;
  tender_Published_Date?: Date;
  pre_Proposal_Meeting_Date?: Date;
  q_A_Date?: Date;
  due_Date?: Date;
  status?: string;
  status_Comment?: string;
  added_By?: string;
  added_By_ID?: number;
  added_On?: Date;
  updated_By?: string;
  updated_On?: Date;
  assigned_By?: string;
  assigned_To?: string;
  assignedToId?: number;
  assigned_At?: Date;
  tender_Client?: string;
  vendor_Company?: string;
  client_Category?: string;
  client_Category_ID?: number;
  service_Department?: number;
  service_Department_Name?: string;
  service_Location?: string;
  proposal_Assigned_At?: Date;
  rfP_Number: string;
  canEdit: boolean,
}

interface ITodaysCount {
  addedOn?: number;
  dueOn?: number;
  preProposalMeetingOn?: number;
  publishedOn?: number;
  qaOn?: number;
}

const status_NameDraft = [
  { name: "Draft", value: "Draft", color: "#64748B" },
  { name: "Go", value: "Go", color: "#22C55E" },
  { name: "No Go", value: "No Go", color: "#EF4444" },
];

const status_NameGO = [
  // { name: "Go", value: "Go", color: "#22C55E" },
  { name: "No Go", value: "No Go", color: "#EF4444" },
  // { name: "Uploaded", value: "Uploaded", color: "#3B82F6" },
  // { name: "Assigned", value: "Assigned", color: "#8B5CF6" },
  { name: "In Review", value: "In Review", color: "#F59E0B" },
  // { name: "Workstream Created", value: "Workstream Created", color: "#06B6D4" },
  // { name: "In Progress", value: "In Progress", color: "#F97316" },
  { name: "Completed", value: "Completed", color: "#22C55E" },
];

const statusschema = yup.object({
  status: yup.string().trim().required("Status is required"),
  allocate: yup.boolean().when("status", (val) => {
    return val === "Go" ? yup.boolean().nullable() : yup.boolean().required("This is required");
  }),
  proposalWriter: yup.number().when("status", (val) => {
    return val === "Go" ? yup.number().required("Bid-Manager selection is required") : yup.number().nullable();
  }),
});
export const Table = (props: IProps) => {
  const [tableData, setTableData] = useState<{ tableData: ITenderMastList[]; loading: boolean }>({ tableData: [], loading: false });
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const [historyModal, setHistoryModal] = useState<boolean>(false);
  const [openAssigned, setOpenAssigned] = useState({ open: false, singleData: {} } as { open: boolean; singleData: ITenderMast });
  const [selectedTenderId, setSelectedTenderId] = useState<number | null>(null);
  const [statusDialog, setStatusDialog] = useState(false);
  const [statusDialogLoading, setStatusDialogLoading] = useState(false);
  const [selectedTender, setSelectedTender] = useState<any>(null);
  const [statusComment, setStatusComment] = useState<string>("");
  const [workStream, setWorkStream] = useState({ open: false, singleData: {} as ITenderMast });
  const [openDocList, setOpenDocList] = useState({ open: false, singleData: {} as ITenderMastList });
  const [todaysCount, setTodaysCount] = useState({} as ITodaysCount);
  const [proposalWriters, setProposalWriters] = useState<Array<{ login_ID?: number; name?: string }>>([]);
  const [filter, setFilter] = useState<ITenderFilter>({
    dateRange: null,
    companyId: null,
    branchIds: [],
    categoryId: null,
    vendorCompanyId: 0,
    assignedTo: null,
    assignedToBM: null,
    status: null,
    publishedDateRange: null,
    preProposalMeetingDateRange: null,
    qADateRange: null,
    dueDateRange: null,
    added_Today: false,
    published_Today: false,
    preProposalMeeting_Today: false,
    qA_Today: false,
    due_Today: false,
    rfP_Number: null,
  });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });
  const DateFormat = loginObj.date_Format;
  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    setValue: setStatusValue,
    formState: { errors: error, isDirty },
    reset: resetStatus,
    watch,
  } = useForm<{ status: string; allocate: boolean; proposalWriter: number }>({
    resolver: yupResolver(statusschema),
    defaultValues: { status: "", allocate: false, proposalWriter: 0 },
    shouldFocusError: false,
  });

  const selectedStatus: string = watch("status") as string;
  const selectedClient: boolean = watch("allocate") as boolean;

  const saveStatus = async (data: { status: string; proposalWriter: number; allocate: boolean }) => {
    if (!selectedTender) return;
    if (data.status === selectedTender.status) {
      props.toast.current.show({ severity: "warn", detail: "Status is already the same.", life: 3000 });
      return;
    }
    if (data.status === "Go") {
      if (statusComment.trim().length === 0) {
        props.toast.current.show({ severity: "warn", detail: "Please enter comment for why Go Status.", life: 3000 });
        return;
      }

      if (!data.proposalWriter || data.proposalWriter === 0) {
        props.toast.current.show({ severity: "warn", detail: "Please assign a Proposal Writer.", life: 3000 });
        return;
      }
    }

    if (data.status === "No Go" && statusComment.length === 0) {
      props.toast.current.show({ severity: "warn", detail: "Please enter comment for why No Go Status.", life: 3000 });
      return;
    }

    setStatusDialogLoading(true);

    const updateStatusBody = {
      id: selectedTender.id,
      status: data.status,
      Status_Comment: statusComment,
      proposalWriter: data.proposalWriter,
      Type: data.allocate,
    };

    const response = await Fetch("Tender_Mast/UpdateStatus", "PUT", updateStatusBody, null, props.toast);

    if (response?.ok) {
      props.toast.current.show({ severity: "success", detail: "Status updated successfully", life: 3000 });
      setStatusDialog(false);
      setStatusComment("");
      resetStatus();
      setSelectedTender(null);
      loadTenderclient();
      setStatusDialogLoading(false);
    } else setStatusDialogLoading(false);
  };

  const loadTenderclient = async () => {
    try {
      setTableData((prev) => ({ ...prev, loading: true }));

      const filterPayload = {
        FromDate: filter.dateRange?.[0] ?? null,
        ToDate: filter.dateRange?.[1] ?? null,
        CompanyId: filter.companyId,
        BranchIds: filter.branchIds,
        CategoryId: filter.categoryId,
        VendorCompanyId: filter.vendorCompanyId,
        assignedTo: filter.assignedTo,
        AssignedToBM: filter.assignedToBM,
        Status: filter.status,
        PublishedFromDate: filter.publishedDateRange?.[0] ?? null,
        PublishedToDate: filter.publishedDateRange?.[1] ?? null,

        PreProposalMeetingFromDate: filter.preProposalMeetingDateRange?.[0] ?? null,
        PreProposalMeetingToDate: filter.preProposalMeetingDateRange?.[1] ?? null,

        QAFromDate: filter.qADateRange?.[0] ?? null,
        QAToDate: filter.qADateRange?.[1] ?? null,

        DueFromDate: filter.dueDateRange?.[0] ?? null,
        DueToDate: filter.dueDateRange?.[1] ?? null,
        Added_Today: filter.added_Today,
        Published_Today: filter.published_Today,
        PreProposalMeeting_Today: filter.preProposalMeeting_Today,
        QA_Today: filter.qA_Today,
        Due_Today: filter.due_Today,
        RFP_Number: filter.rfP_Number,
      };

      const queryParam = `filters=${encodeURIComponent(JSON.stringify(filterPayload))}`;
      const response = await Fetch("Tender_Mast/GetTendor", "GET", null, queryParam, props.toast);

      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  const openFileUpload = (data: ITenderMastList) => {
    setOpenDocList({ open: true, singleData: data });
  };

  const loadTodaysDatesCount = async () => {
    const response = await Fetch("Tender_Mast/getTodaysDatesCount", "GET", null, null, props.toast);
    if (response) {
      const data: ITodaysCount = await response.json();
      setTodaysCount(data);
    }
  };

  useEffect(() => {
    loadTodaysDatesCount();
    loadTenderclient();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reload, filter]);

  const leftToolbarTemplate = () => {
    return (
      <>
        <div className="my-2">
          <Button
            icon="pi pi-refresh"
            className="p-button-rounded p-button-info mr-2"
            onClick={() =>
              setFilter({
                dateRange: null,
                companyId: null,
                branchIds: [],
                categoryId: null,
                vendorCompanyId: null,
                assignedTo: null,
                assignedToBM: null,
                status: null,
                publishedDateRange: null,
                preProposalMeetingDateRange: null,
                qADateRange: null,
                dueDateRange: null,
                added_Today: false,
                published_Today: false,
                preProposalMeeting_Today: false,
                qA_Today: false,
                due_Today: false,
              })
            }
          />
          {(_roles.includes(54) || _roles.includes(1) || _roles.includes(56)) && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
        </div>
      </>
    );
  };

  // added_Today
  // published_Today
  // preProposalMeeting_Today
  // qA_Today
  // due_Today

  const rightToolbarTemplate = () => {
    //todaysCount
    return (
      <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
        {/* <h5 className="m-0">RPF</h5> */}
        <span className="block mt-2 md:mt-0 p-input-icon-left">
          <div style={{ display: "flex" }}>
            <Button label={`Added : ${todaysCount.addedOn ?? 0}`} className={`${filter.added_Today ? "p-button-success" : "bg-green-500"} px-2 py-2 mx-1`} tooltip={`RFP Added Today`} tooltipOptions={{ position: "top" }} onClick={() => setFilter({ ...filter, added_Today: true, published_Today: false, preProposalMeeting_Today: false, qA_Today: false, due_Today: false })} />
            <Button label={`Published : ${todaysCount.publishedOn ?? 0}`} className={`${filter.published_Today ? "p-button-info" : "bg-blue-500"} px-2 py-2 mx-1`} tooltip={`Published Today`} tooltipOptions={{ position: "top" }} onClick={() => setFilter({ ...filter, added_Today: false, published_Today: true, preProposalMeeting_Today: false, qA_Today: false, due_Today: false })} />
            <Button
              label={`Pre Proposal Meeting : ${todaysCount.preProposalMeetingOn ?? 0}`}
              className={`${filter.preProposalMeeting_Today ? "p-button-warning" : "bg-yellow-500"} px-2 py-2 mx-1`}
              tooltip={`Pre Proposal Meeting Today`}
              tooltipOptions={{ position: "top" }}
              onClick={() => setFilter({ ...filter, added_Today: false, published_Today: false, preProposalMeeting_Today: true, qA_Today: false, due_Today: false })}
            />
            <Button label={`Q & A : ${todaysCount.qaOn ?? 0}`} className={`${filter.qA_Today ? "p-button-help" : "bg-purple-500"} px-2 py-2 mx-1`} tooltip={`Q & A Today`} tooltipOptions={{ position: "top" }} onClick={() => setFilter({ ...filter, added_Today: false, published_Today: false, preProposalMeeting_Today: false, qA_Today: true, due_Today: false })} />
            <Button
              label={`Due Date : ${todaysCount.dueOn ?? 0}`}
              style={filter.due_Today ? { backgroundColor: "#EF4444", borderColor: "#EF4444", color: "#fff" } : { backgroundColor: "#FCA5A5", borderColor: "#FCA5A5", color: "#fff" }}
              tooltip={`Due Date Today`}
              tooltipOptions={{ position: "top" }}
              onClick={() => setFilter({ ...filter, added_Today: false, published_Today: false, preProposalMeeting_Today: false, qA_Today: false, due_Today: true })}
            />
          </div>
        </span>
      </div>
    );
  };

  const openNew = () => {
    props.setModal({ singleData: EmptyTenderMast, open: true });
  };

  // const downloadDoc = async (tenderID: number) => {
  //   const params = {
  //     method: "GET",
  //     headers: { "Content-Type": "application/msword", Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}` },
  //   };

  //   try {
  //     const response = await fetch(`${baseUrl}${"Tender_Mast/download"}?tenderID=${tenderID}`, params);
  //     if (response.status === 200) {
  //       const blob = await response.blob();

  //       const disposition = response.headers.get("content-disposition");
  //       let fileName = `Tender_Document`;

  //       if (disposition) {
  //         const match = disposition.match(/filename="?([^"]+)"?/);
  //         if (match?.[1]) {
  //           fileName = match[1];
  //         }
  //       }

  //       const href = URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = href;
  //       a.download = fileName;
  //       document.body.appendChild(a);
  //       a.click();

  //       document.body.removeChild(a);
  //       URL.revokeObjectURL(href);
  //     } else if (response.status === 400) {
  //       const message = await response.text();
  //       props.toast.current.show({ severity: "error", detail: message, life: 3000 });
  //     }
  //   } catch {
  //     props.toast.current.show({ severity: "error", detail: "Something went Wrong", life: 3000 });
  //   }
  // };
  // const download = (rowData: ITenderMast) => {
  //   return rowData.tender_Doc_Path ? (
  //     <Button icon="pi pi-download" label="Download Document" className="p-button-rounded p-button-success p-button-text mr-1"
  //       onClick={() => { downloadDoc(rowData.id!); }}
  //     />
  //   ) : (
  //     <></>
  //   );
  // };

  const openHistory = (tenderId: number) => {
    setSelectedTenderId(tenderId);
    setHistoryModal(true);
  };

  const loadProposalWriter = async (categoryId: number) => {
    const respone = await Fetch("Tender_Mast/GetProposalWriterUser", "GET", null, `categoryId=${categoryId}`, null);
    if (respone) {
      const data: { login_ID?: number; name?: string }[] = await respone.json();
      setProposalWriters(data);
    }
  };

  const statusColors: Record<string, string> = {
    Draft: "#64748B",
    Go: "#22C55E",
    "No Go": "#EF4444",
    // Uploaded: "#3B82F6",
    Assigned: "#8B5CF6",
    "In Review": "#F59E0B",
    "Workstream Created": "#06B6D4",
    // "In Progress": "#F97316",
    Completed: "#22C55E",
  };

  const tenderStatus = (rowData: any) => {
    const dotColor = statusColors[rowData.status ?? ""] || "#64748B";
    return (
      <span
        style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
        onClick={() => {
          if (rowData.status === "Completed" && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))) {
            props.toast.current.show({ severity: "warn", detail: "Completed RFP can only be changed by Admin.", life: 3000 });
            return;
          }
          if (rowData.status === "No Go" && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))) {
          } else if (_roles.includes(1) || _roles.includes(26) || _roles.includes(53) || _roles.includes(56)) {
            setSelectedTender(rowData);
            setStatusValue("status", rowData.status ?? "");
            setStatusDialog(true);
            if (rowData.status === "Draft") loadProposalWriter(rowData.client_Category_ID);
          } else props.toast.current.show({ severity: "warn", detail: "Status Can Be Changed By Bid-Managers.", life: 3000 });
        }}
      >
        <i
          className="pi pi-circle-fill"
          style={{
            color: dotColor,
            fontSize: "0.6rem",
            marginRight: "10px",
          }}
        />
        {rowData.status}
      </span>
    );
  };

  const autoAllocateProposalWriter = async () => {
    const response = await Fetch("Tender_Mast/AutoAllocateProposalWriter", "GET", null, `categoryId=${selectedTender.client_Category_ID}`, props.toast);
    if (response?.ok) {
      const data = await response.json();
      setProposalWriters([data]);
      setStatusValue("proposalWriter", data.login_ID);
    }
  };
  useEffect(() => {
    if (selectedStatus !== "Go") return;
    if (selectedClient) {
      autoAllocateProposalWriter();
    } else {
      loadProposalWriter(selectedTender.client_Category_ID!);
      setStatusValue("proposalWriter", 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClient, selectedStatus, selectedTender]);

  const statusTemplate = (option: any) => {
    if (!option) return <span>Select Status</span>;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <i
          className="pi pi-circle-fill"
          style={{
            color: option.color,
            fontSize: "0.6rem",
          }}
        />
        <span>{option.name}</span>
      </div>
    );
  };

  const rfpstatusColors: Record<string, { bg: string; text: string }> = {
    Created: { bg: "#E2E8F0", text: "#475569" },
    Verified: { bg: "#DBEAFE", text: "#1D4ED8" },
    Approved: { bg: "#DCFCE7", text: "#15803D" },
    Closed: { bg: "#E2E8F0", text: "#334155" },
  };

  const rfpstatusBodyTemplate = (rowData: any) => {
    const workstreamStatus: string[] = rowData.workstreamStatus || [];

    const counts = {
      Created: workstreamStatus.filter((x) => x.startsWith("Created")).length,
      Verified: workstreamStatus.filter((x) => x.startsWith("Verified")).length,
      Approved: workstreamStatus.filter((x) => x.startsWith("Approved")).length,
      Closed: workstreamStatus.filter((x) => x.startsWith("Closed")).length,
    };

    const activeStatuses = Object.entries(counts).filter(([, count]) => count > 0);

    if (activeStatuses.length === 0) {
      return <span style={{ fontSize: 12, color: "#94A3B8" }}> No available status </span>;
    }

    return (
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", maxWidth: 220 }}>
        {activeStatuses.map(([status, count]) => {
          const colors = rfpstatusColors[status];
          return (
            <span key={status} title={`${status}: ${count}`} style={{ background: colors.bg, color: colors.text, fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 999, whiteSpace: "nowrap" }}>
              {status} {count}
            </span>
          );
        })}
      </div>
    );
  };

  const rfpStatusHide = () => {
    setStatusComment("");
    setStatusDialog(false);
    resetStatus();
    setSelectedTender(null);
  };

  const hideTenderMastHistory = () => {
    setHistoryModal(false);
    setSelectedTenderId(null);
  };
  return (
    <>
      <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3" />
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filter={filter} setFilter={setFilter} />
        </AccordionTab>
      </Accordion>
      <DataTable removableSort value={tableData.tableData} loading={tableData.loading} size="small" stripedRows showGridlines responsiveLayout="scroll" header="Request For Proposal List">
        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
        <Column field="client_Category" header="Client Category" />
        <Column field="vendor_Company" header="Client" />
        <Column field="service_Department_Name" header="Service Department" />
        <Column field="tender_Client" header="Contact Person" />
        <Column field="tender_Published_Date" header="RFP Published Date" body={(rowData: ITenderMastList) => safeFormatDate(new Date(rowData?.tender_Published_Date || "").toString(), "dd/MM/yyyy", DateFormat)} sortable />
        <Column field="pre_Proposal_Meeting_Date" header="Pre Proposal Meeting Date" body={(rowData: ITenderMastList) => safeFormatDate(new Date(rowData?.pre_Proposal_Meeting_Date || "").toString(), "dd/MM/yyyy", DateFormat)} sortable />
        <Column field="q_A_Date" header="Q & A Date" body={(rowData: ITenderMastList) => safeFormatDate(new Date(rowData?.q_A_Date || "").toString(), "dd/MM/yyyy", DateFormat)} sortable />
        <Column field="due_Date" header="Due Date" body={(rowData: ITenderMastList) => safeFormatDate(new Date(rowData?.due_Date || "").toString(), "dd/MM/yyyy", DateFormat)} sortable />
        <Column field="title" header="Title" />
        <Column field="rfP_Number" header="RFP Number" body={(rowData) => <span style={{ background: "#eff6ff", color: "#1d4ed8", padding: "4px 8px", borderRadius: "5px", fontWeight: 600, fontSize: "12px" }}>{rowData.rfP_Number ?? "-"}</span>} />
        <Column
          header="Description"
          body={(rowData: ITenderMast) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData.description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column header="Documents" body={(rowData: ITenderMastList) => <Button icon="pi pi-cloud-download" className="p-button-rounded" onClick={() => openFileUpload(rowData)} tooltip="Download Document" tooltipOptions={{ position: "top" }} />} />
        <Column field="assigned_ToBM" header="Assigned To Bid-Manager" />
        <Column field="assigned_To" header="Assigned To Proposal Writer" />
        <Column field="assigned_By" header="Proposal Assigned By" />
        <Column field="proposal_Assigned_At" header="Proposal Assigned At" body={(rowData: ITenderMastList) => safeFormatDate((rowData?.proposal_Assigned_At || "").toString(), "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column
          header="History"
          body={(rowData: ITenderMastList) => (
            <span className="cursor-pointer" onClick={() => openHistory(rowData.id || 0)}>
              <i className="pi pi-history" style={{ color: "var(--primary-color)" }} />
            </span>
          )}
        />
        <Column
          header="Actions"
          body={(rowData: ITenderMastList) =>
            rowData.status !== "No Go" && rowData.status !== "Completed" ? (
              <div className="flex gap-2">
                {(rowData.canEdit !== undefined && rowData.canEdit !== null && rowData.canEdit === true) && (
                  <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text"
                    onClick={() =>
                      props.setModal({
                        singleData: {
                          id: rowData.id,
                          contact_Person_ID: rowData.contact_Person_ID ?? 0,
                          title: rowData.title,
                          minBidAmnt: rowData.minBidAmnt,
                          description: rowData.description,
                          added_On: rowData.added_On,
                          updated_On: rowData.updated_On,
                          tender_Published_Date: rowData.tender_Published_Date,
                          pre_Proposal_Meeting_Date: rowData.pre_Proposal_Meeting_Date,
                          q_A_Date: rowData.q_A_Date,
                          due_Date: rowData.due_Date,
                          assigned_To: rowData.assigned_To,
                          assignedToId: rowData.assignedToId,
                          status: rowData.status,
                          service_Department: rowData.service_Department,
                          added_By: rowData.added_By,
                          added_By_ID: rowData.added_By_ID,
                          rfP_Number: rowData.rfP_Number,
                        },
                        open: true,
                      })
                    }
                  />
                )}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(53) || _roles.includes(55) || _roles.includes(56)) && (
                  <Button
                    icon="pi pi-sitemap"
                    className="p-button-rounded p-button-text p-button-warning"
                    tooltip="Work Stream"
                    onClick={() =>
                      setWorkStream({
                        open: true,
                        singleData: {
                          id: rowData.id,
                          contact_Person_ID: rowData.contact_Person_ID ?? 0,
                          title: rowData.title,
                          description: rowData.description,
                          added_On: rowData.added_On,
                          updated_On: rowData.updated_On,
                          tender_Published_Date: rowData.tender_Published_Date,
                          pre_Proposal_Meeting_Date: rowData.pre_Proposal_Meeting_Date,
                          q_A_Date: rowData.q_A_Date,
                          due_Date: rowData.due_Date,
                          assigned_To: rowData.assigned_To,
                          assignedToId: rowData.assignedToId,
                          status: rowData.status,
                          added_By: rowData.added_By,
                          added_By_ID: rowData.added_By_ID,
                          client_Category_Name: rowData.client_Category,
                          vendor_Company_Name: rowData.vendor_Company,
                          service_Department_Name: rowData.service_Department_Name,
                          tender_Client: rowData.tender_Client,
                          rfP_Number: rowData.rfP_Number,
                        },
                      })
                    }
                  />
                )}
              </div>
            ) : (
              <></>
            )
          }
        />
        <Column header="RFP Status" body={tenderStatus} style={{ minWidth: "120px" }} />
        <Column header="Workstream Status" body={rfpstatusBodyTemplate} />
        <Column field="added_By" header="Added By" />
        <Column field="added_On" header="Added On" body={(rowData: ITenderMastList) => safeFormatDate(new Date(rowData?.added_On || "").toString(), "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} sortable />
        <Column field="updated_By" header="Updated By" />
        <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} sortable />
      </DataTable>
      {/* Description */}
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>

      {/* RFP Status Dialog */}
      <Dialog header="RFP Status" visible={statusDialog} modal style={{ width: "50vw" }} onHide={rfpStatusHide}>
        <form onSubmit={handleStatusSubmit(saveStatus)}>
          <div className="p-fluid formgrid grid">
            <JVDropdown required column={1} label="Status" control={statusControl} name="status" options={selectedTender?.status === "Draft" ? status_NameDraft : status_NameGO} optionLabel="name" optionValue="value" placeholder="Select Status" error={error.status?.message} itemTemplate={statusTemplate} valueTemplate={statusTemplate} />
            {selectedStatus === "Go" && selectedTender.status !== "Go" && <JVCheckbox column={2} label="Auto Allocate Proposal Writer" control={statusControl} name="allocate" />}
            {selectedStatus === "Go" && selectedTender.status !== "Go" && <JVDropdown required column={2} disabled={selectedClient} label="Proposal Writer" control={statusControl} name="proposalWriter" options={proposalWriters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Proposal Writer" error={error.proposalWriter?.message} />}
            <div className="field col-12">
              <label>Comment</label>
              <InputTextarea value={statusComment} onChange={(e) => setStatusComment(e.target.value)} rows={4} cols={30} className="w-full" placeholder="Enter Status Comment" />
            </div>
            <div className="field col-12 flex justify-content-end gap-2">
              <Button label="Save" icon="pi pi-check" loading={statusDialogLoading} type="submit" disabled={!isDirty} />
              <Button label="Clear" icon="pi pi-times" type="button" className="p-button-secondary" onClick={() => resetStatus()} />
            </div>
          </div>
        </form>
      </Dialog>
      <TenderAssigned openAssigned={openAssigned} onHide={() => setOpenAssigned({ open: false, singleData: {} as ITenderMast })} toast={props.toast} loadTableData={loadTenderclient} />
      <TenderWorkStream open={workStream.open} singleData={workStream.singleData} toast={props.toast} onHide={() => setWorkStream({ open: false, singleData: {} as ITenderMast })} reloadTable={loadTenderclient} />
      <TenderMastHistory visible={historyModal} tenderId={selectedTenderId} toast={props.toast} onHide={hideTenderMastHistory} />
      <DocumentList open={openDocList.open} singleData={openDocList.singleData} toast={props.toast} onHide={() => setOpenDocList({ open: false, singleData: {} as ITenderMastList })} />
    </>
  );
};
